import { AbstractEntity } from './AbstractEntity'

export class TenantEntity extends AbstractEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get tenantId() {
    return this._data.tenantId
  }
  set tenantId(tenantId) {
    if (tenantId !== 0) {
      tenantId = tenantId || -1
    }
    this._data.tenantId = tenantId
  }
}
